<template>
	<div v-if="!hasError" class="ai-mock-main-container position-relative">
		<section
			class="d-flex align-items-center justify-content-center mob-justify-center"
		>
			<div>
				<img
					src="../../assets/NewDashboard/mockinterview-heading.svg"
					id="hideinmobile"
					alt=""
				/>
				<img
					src="../../assets/NewDashboard/mockinterview-heading=mobile.svg"
					id="hideinlaptop"
					alt=""
				/>
			</div>
		</section>
		<div
			id="hideinmobile"
			class="exploremore-btn aim-exploremorebtn-laptop mr-24px ml-75px pointer"
		>
			<div class="padding816px" @click="navigateToSkills('bycompany')">
				Explore More
			</div>
		</div>
		<div class="aicards-wrapper">
			<div
				class="aicards-viewport"
				ref="viewport"
				@touchstart.passive="onTouchStart"
				@touchend.passive="onTouchEnd"
			>
				<div class="aicards-track" :style="trackStyle">
					<!-- Loading skeleton -->
					<template v-if="loading">
						<div
							v-for="i in 5"
							:key="'skeleton-' + i"
							class="ai-mock-interview-card ai-mock-loading-card"
							:class="{ active: i === 3 }"
						>
							<div
								class="ai-mock-interview-card-innercontainer"
								:class="getSkeletonColor(i)"
							>
								<b-skeleton width="92%" height="14px"></b-skeleton>
								<div class="mt-10px">
									<b-skeleton width="68%" height="14px"></b-skeleton>
								</div>
								<div class="mt-10px">
									<b-skeleton width="52%" height="10px"></b-skeleton>
								</div>
								<div class="mt-10px d-flex align-items-center gap-5px">
									<b-skeleton width="56px" height="21px"></b-skeleton>
									<b-skeleton width="44px" height="21px"></b-skeleton>
								</div>
								<div class="mt-10px d-flex align-items-center gap-5px">
									<b-skeleton
										type="circle"
										width="32px"
										height="32px"
									></b-skeleton>
									<b-skeleton width="78px" height="10px"></b-skeleton>
								</div>
							</div>
						</div>
					</template>
					<!-- Real cards -->
					<template v-else>
						<div
							v-for="(card, index) in displayCards"
							:key="index"
							class="ai-mock-interview-card"
							:class="{
								active: index === activeDomIndex,
								'no-card-transition': !animateCards,
							}"
						>
							<div
								class="ai-mock-interview-card-innercontainer"
								:class="getCardColor(index)"
							>
								<div
									class="ami-icon-card-container d-flex justify-content-center align-items-center"
								>
									<img
										src="../../assets/NewDashboard/ja.svg"
										alt=""
										height="24px"
										width="24px"
										class="overflow-hidden"
									/>
								</div>
								<div class="fw-M fs-14 fam-mont color-1F1F1F mt-10px w-100">
									<div class="text-capitalize w-100 text-truncate">
										{{ card.role }}
									</div>
								</div>
								<div
									class="aim-company-name fw-M fs-14 fam-mont w-100 text-truncate"
									:class="getCardColor(index)"
								>
									{{ card.companyName }}
								</div>
								<div class="mt-10px fs-10 fw-M fam-mont color-6573A2">
									Based on your profile
								</div>
								<div class="mt-5px d-flex align-items-center gap-5px flex-wrap">
									<div
										class="ami-cards-tags text-capitalize text-truncate"
										:class="[
											getCardColor(index),
											{ 'ami-cards-tags-solo': !card.experience },
										]"
									>
										{{ card.skill }}
									</div>
									<div
										v-if="card.experience"
										class="ami-cards-tags text-truncate"
										:class="getCardColor(index)"
									>
										{{ card.experience }}&nbsp; Yrs Exp
									</div>
								</div>
								<div
									class="ami-match-row mt-10px d-flex align-items-center gap-5px w-100"
								>
									<div class="ami-ring-wrap">
										<svg width="32" height="32" viewBox="0 0 32 32">
											<circle
												class="ami-ring-track"
												cx="16"
												cy="16"
												r="13"
												fill="none"
												stroke="#d8e3f7"
												stroke-width="3"
											/>
											<circle
												class="ami-ring-progress"
												cx="16"
												cy="16"
												r="13"
												fill="none"
												stroke="#4a7eff"
												stroke-width="3"
												stroke-linecap="round"
												stroke-dasharray="81.68"
												:stroke-dashoffset="
													getProgressOffset(card.matchPercent)
												"
												transform="rotate(-90 16 16)"
											/>
										</svg>
										<span class="ami-ring-label fw-B">{{
											card.matchPercent ? `${card.matchPercent}%` : "??"
										}}</span>
									</div>
									<span class="ami-match-text">{{
										card.matchPercent
											? "Profile match percentage"
											: "Profile match not available"
									}}</span>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>

			<div
				@click="prevCard"
				v-if="cardCount > 1"
				class="aimock-interview-arws left"
				id="hideinmobile"
			>
				<img src="../../assets/NewDashboard/light-bluearrow.svg" alt="" />
			</div>
			<div
				@click="nextCard"
				v-if="cardCount > 1"
				class="aimock-interview-arws right"
				id="hideinmobile"
			>
				<img src="../../assets/NewDashboard/light-bluearrow.svg" alt="" />
			</div>
		</div>

		<div
			class="w-100 d-flex mob-align-center justify-content-center mob-flex-col"
		>
			<button
				class="new-light-blue-btn fam-mont text-white d-flex align-items-center justify-content-center fw-M fs-14 text-center pointer ai-start-interview-btn"
				@click="startInterview()"
			>
				Start AI Interview
				<img src="../../assets/NewDashboard/whitedirection-arw.svg" alt="" />
			</button>

			<div id="hideinlaptop" class="exploremore-btn pointer mt-10px">
				<div class="padding816px" @click="navigateToSkills('bycompany')">
					Explore More
				</div>
			</div>
		</div>

		<PaymentComingSoonModal :showModal.sync="showPaymentComingSoonModal" />
	</div>
</template>

<script>
const CARD_WIDTH = 245;
const GAP = 16;
const STEP = CARD_WIDTH + GAP;

import { getMockInterviews, getProfileSkills } from "@/utils/apiFunctions.js";
import { hasAccess as checkHasAccess } from "@/utils/tokenCheck";
import EventBus from "@/utils/EventBus";
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";

export default {
	components: {
		PaymentComingSoonModal,
	},
	data() {
		return {
			cards: [],
			loading: true,
			realIndex: 0, // which card (0-4) is highlighted
			offset: 0, // current translateX in px (negative = moved left)
			animate: true,
			animateCards: true,
			isScrolling: false,
			activeDomIndex: 0,
			touchStartX: 0,
			touchStartY: 0,
			isMobile: false,
			mockInterviewTaken: 0,
			showPaymentComingSoonModal: false,
			hasError: false,
			skeletonOffset: 0,
		};
	},

	computed: {
		hasAccess() {
			return checkHasAccess();
		},
		displayCards() {
			const list = this.isMobile ? this.cards.slice(0, 3) : this.cards;
			return [...list, ...list, ...list];
		},

		cardCount() {
			return this.isMobile ? Math.min(3, this.cards.length) : this.cards.length;
		},

		trackStyle() {
			if (this.loading) {
				// Keep the skeleton centred on its middle card so the loading
				// state matches the loaded carousel instead of starting flush left.
				return {
					transform: `translateX(${this.skeletonOffset}px)`,
					transition: "none",
				};
			}
			return {
				transform: `translateX(${this.offset}px)`,
				transition: this.animate ? "transform 0.4s ease" : "none",
			};
		},

		setWidth() {
			return this.cardCount * STEP;
		},
	},

	created() {
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
		this.createdActions();
	},

	mounted() {
		this.onResize();
		window.addEventListener("resize", this.onResize);

		this.$nextTick(() => {
			this.animate = false;
			this.activeDomIndex = this.cardCount;
			this.offset = this.centreOffset(this.activeDomIndex);
			this.skeletonOffset = this.centreOffset(2);
		});

		// Recalculate center on resize/zoom
		this._resizeObserver = new ResizeObserver(() => {
			this.animate = false;
			this.offset = this.centreOffset(this.activeDomIndex);
			this.skeletonOffset = this.centreOffset(2);
		});
		if (this.$refs.viewport) {
			this._resizeObserver.observe(this.$refs.viewport);
		}
	},

	beforeDestroy() {
		window.removeEventListener("resize", this.onResize);
		if (this._resizeObserver) this._resizeObserver.disconnect();
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
	},

	methods: {
		createdActions() {
			this.fetchMockInterviews();
			this.fetchMockInterviewTaken();
		},
		navigateToSkills(type) {
			this.$router.push({
				name: "InterviewSkills",
				query: {
					...this.$route.query,
					[type]: true,
					from: "dashboard",
				},
			});
		},
		openLoginModal() {
			EventBus.$emit("open-login-modal");
		},
		saveStateToVuex() {
			this.$store.commit("candidateVUEX/setSavedInterviewSkillState", {
				searchedSkills: [],
				recentSearch: [],
				byCompany: true,
			});
		},
		startInterview() {
			if (!this.hasAccess) {
				this.openLoginModal();
				return;
			}
			const activeCard = this.cards[this.realIndex];
			if (!activeCard) return;
			// Same free-attempt limit as on the InterviewSkills page:
			// block after 2 interviews and show the coming-soon/payment modal
			if (this.mockInterviewTaken >= 2) {
				this.showPaymentComingSoonModal = true;
				return;
			}
			// Interview is taken BY COMPANY (not by skill): commit the company as
			// selectedCompany and its skills as the interview skills, mirroring the
			// existing byCompany flow used on the InterviewSkills page.
			const company = this.buildCompanyObject(activeCard);
			this.$store.commit(
				"candidateVUEX/setSelectedSkillsForInterview",
				this.companySkillsFor(activeCard)
			);
			this.$store.commit("candidateVUEX/setSelectedCompany", company);
			this.saveStateToVuex();
			this.$router.push({
				name: "TakeAiInterview",
				query: { ...this.$route.query, bycompany: true },
			});
		},
		// Normalize the skills list expected by the company interview flow.
		// Prefers the raw item's companySkills/skills array; falls back to a
		// single-skill array from the card so SystemCheck's .map() always works.
		companySkillsFor(card) {
			const raw = card.company;
			const skills = (raw && (raw.companySkills || raw.skills)) || [];
			if (Array.isArray(skills) && skills.length) return skills;
			return card.skill ? [card.skill] : [];
		},
		// Build a selectedCompany object compatible with SystemCheck (needs
		// company_name + role) using the raw card item's fields.
		buildCompanyObject(card) {
			const raw = card.company || {};
			const companyName =
				raw.companyName || raw.company_name || card.companyName || "";
			const role =
				raw.role || raw.companyRoleName || raw.title || card.role || "";
			return {
				...raw,
				companyName,
				company_name: companyName,
				role,
				companyRoleName: raw.companyRoleName || raw.role || role,
				companySkills: this.companySkillsFor(card),
			};
		},
		async fetchMockInterviewTaken() {
			try {
				const resp = await getProfileSkills();
				if (resp && resp.status === 200) {
					this.mockInterviewTaken =
						resp.data?.data?.data?.mock_interview_taken ?? 0;
				}
			} catch (err) {
				console.error("Error fetching mock interview count:", err);
			}
		},
		onResize() {
			const isMobile = window.innerWidth <= 1028;
			if (isMobile !== this.isMobile) {
				this.isMobile = isMobile;
				this.realIndex = 0;
				this.$nextTick(() => {
					this.animate = false;
					this.activeDomIndex = this.cardCount;
					this.offset = this.centreOffset(this.activeDomIndex);
					this.skeletonOffset = this.centreOffset(2);
				});
			}
		},
		mapInterviewCards(list) {
			return (list || []).map((item) => ({
				title: item.role || item.companyName || "Mock Interview",
				role: item.role || "",
				companyName: item.companyName || item.company_name || "",
				skill: item.skill || "",
				experience: item.experience || "",
				matchPercent: Math.round((Number(item.matchScore) || 0) * 100),
				company: item, // keep the raw company item for the by-company interview
			}));
		},

		async fetchMockInterviews() {
			this.loading = true;
			try {
				const res = await getMockInterviews();
				const payload = res && res.data;
				let list = [];
				if (Array.isArray(payload)) list = payload;
				else if (Array.isArray(payload && payload.data)) list = payload.data;
				else if (Array.isArray(payload && payload.data && payload.data.data))
					list = payload.data.data;

				if (list.length) {
					this.cards = this.mapInterviewCards(list);
					this.hasError = false;
					this.$nextTick(() => {
						this.realIndex = 0;
						this.animate = false;
						this.activeDomIndex = this.cardCount;
						this.offset = this.centreOffset(this.activeDomIndex);
					});
				} else {
					// API succeeded but returned no data — don't render the section
					this.hasError = true;
				}
			} catch (err) {
				console.error("Error fetching mock interviews:", err);
				this.hasError = true;
			} finally {
				this.loading = false;
			}
		},

		getCardColor(index) {
			const colors = ["purple", "blue", "grey"];
			return colors[(index % this.cardCount) % colors.length];
		},

		getSkeletonColor(i) {
			const colors = ["purple", "blue", "grey"];
			return colors[(i - 1) % colors.length];
		},

		getProgressOffset(percent) {
			const circumference = 81.68; // 2 * PI * r(13)
			const p = percent ?? 88;
			return circumference - (p / 100) * circumference;
		},

		centreOffset(domIndex) {
			const viewportEl = this.$refs.viewport;
			const viewportWidth = viewportEl ? viewportEl.clientWidth : 801;

			// Measure the real rendered card + gap instead of trusting the module
			// constants (CARD_WIDTH=245 / GAP=16). Under max-width:1028px the cards
			// are resized to 215px with a 12px gap, so the hard-coded constants put
			// the active card off-centre on zoom/mobile.
			let cardWidth = CARD_WIDTH;
			let gap = GAP;
			if (viewportEl) {
				const card = viewportEl.querySelector(".ai-mock-interview-card");
				if (card) cardWidth = Math.round(card.offsetWidth) || cardWidth;
				const track = viewportEl.querySelector(".aicards-track");
				if (track) {
					const colGap = parseFloat(getComputedStyle(track).columnGap);
					if (!Number.isNaN(colGap)) gap = colGap;
				}
			}

			const cardCentre = domIndex * (cardWidth + gap) + cardWidth / 2;

			// Subtract the active card's left margin to compensate for the shift:
			// 24px on desktop, overridden to 16px inside max-width:1028px.
			const activeMargin = viewportWidth <= 1028 ? 16 : 24;

			// Round to a whole pixel so the composited track layer never sits
			// on a fractional translateX — a sub-pixel transform makes the
			// carousel jitter/shake on every vertical page-scroll frame.
			return Math.round(viewportWidth / 2 - cardCentre - activeMargin);
		},

		middleDomIndex(ri) {
			return this.cardCount + ri;
		},

		nextCard() {
			if (this.isScrolling) return;
			this.isScrolling = true;

			const len = this.cardCount;
			this.realIndex = (this.realIndex + 1) % len;

			// If wrapping: animate into the 3rd copy, then silently reset to middle copy
			const isWrapping = this.realIndex === 0;
			const targetDom = isWrapping
				? len * 2
				: this.middleDomIndex(this.realIndex);

			this.activeDomIndex = targetDom;
			this.animate = true;
			this.offset = this.centreOffset(targetDom);

			setTimeout(() => {
				// Disable track + card transitions, then silently reset position
				this.animate = false;
				this.animateCards = false;
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						const midDom = this.middleDomIndex(this.realIndex);
						this.activeDomIndex = midDom;
						this.offset = this.centreOffset(midDom);
						requestAnimationFrame(() => {
							this.animateCards = true;
							this.isScrolling = false;
						});
					});
				});
			}, 420);
		},

		onTouchStart(e) {
			this.touchStartX = e.touches[0].clientX;
			this.touchStartY = e.touches[0].clientY;
		},
		onTouchEnd(e) {
			const touch = e.changedTouches[0];
			const dx = touch.clientX - this.touchStartX;
			const dy = touch.clientY - this.touchStartY;

			// Only treat this as a horizontal card swipe when the horizontal
			// movement clearly dominates vertical. A vertical full-page scroll
			// often drifts a few px sideways — without this check it would
			// wrongly change the card.
			if (Math.abs(dx) < Math.abs(dy)) return;
			if (Math.abs(dx) < 30) return; // ignore tiny taps
			if (dx < 0) this.nextCard();
			else this.prevCard();
		},
		prevCard() {
			if (this.isScrolling) return;
			this.isScrolling = true;

			const len = this.cardCount;
			this.realIndex = (this.realIndex - 1 + len) % len;

			// If wrapping: animate into the 1st copy, then silently reset to middle copy
			const isWrapping = this.realIndex === len - 1;
			const targetDom = isWrapping
				? len - 1
				: this.middleDomIndex(this.realIndex);

			this.activeDomIndex = targetDom;
			this.animate = true;
			this.offset = this.centreOffset(targetDom);

			setTimeout(() => {
				// Disable track + card transitions, then silently reset position
				this.animate = false;
				this.animateCards = false;
				this.$nextTick(() => {
					requestAnimationFrame(() => {
						const midDom = this.middleDomIndex(this.realIndex);
						this.activeDomIndex = midDom;
						this.offset = this.centreOffset(midDom);
						requestAnimationFrame(() => {
							this.animateCards = true;
							this.isScrolling = false;
						});
					});
				});
			}, 420);
		},
	},
};
</script>

<style>
.ami-icon-card-container {
	width: 44px;
	height: 44px;
	background: #ffffff;
	border-radius: 137.5px;
}
.ami-cards-tags {
	padding: 3px 6px;
	border-radius: 84.7525px;
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 10.1703px;
	color: #263238;
	min-height: 21px;
	height: auto;
	white-space: nowrap;
	min-width: auto;
	max-width: 48%;
}
/* No experience tag rendered — the skill tag gets the full row */
.ami-cards-tags-solo {
	max-width: 98%;
}
.ami-cards-tags.purple {
	background: #e3d8f5;
}
.ami-cards-tags.blue {
	background: #d2dff9;
}
.ami-cards-tags.grey {
	background: #dcecdc;
}
.aim-company-name.purple {
	color: #7c34e3;
}
.aim-company-name.blue {
	color: #4a7eff;
}
.aim-company-name.grey {
	color: #318c34;
}
.ml-75px {
	margin-left: 75px;
}
.ami-mainheading {
	font-family: "Figma Hand";
	font-style: normal;
	font-weight: 700;
	font-size: 28px;
	line-height: 1.2;
	text-transform: capitalize;
	background: linear-gradient(177.78deg, #4a7eff 1.87%, #f8fafc 235.23%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	color: transparent;
}
.mr-24px {
	margin-right: 24px;
}
.ai-mock-main-container {
	width: 100%;
	border: 1px solid #e9e9e9;
	/* filter: drop-shadow(0px -2px 5px rgba(255, 255, 255, 0.9))
		drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1)); */
	border-radius: 24px;
	padding: 24px 0;
	background-image: url("~@/assets/NewDashboard/AiMockBanner.png");
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}

.ai-start-interview-btn {
	min-width: 186px;
	max-width: 100%;
	flex-shrink: 1;
}
.ai-start-interview-btn img {
	flex-shrink: 0;
}

/* viewport clips the track — overflow hidden, no scrollbar ever */
.aicards-viewport {
	width: 100%;
	overflow: hidden;
	height: 300px;
	position: relative;
	top: 0;
	/* margin-bottom: 22px; */
}

/* track: flex row, driven purely by translateX */
.aicards-track {
	display: flex;
	gap: 16px;
	/* NOTE: no will-change:transform here. It promoted the very-wide flex row
	   (3x the card copies) to a permanent oversized composited GPU layer that
	   fought the page's vertical scroll compositor on mobile, making the whole
	   card container bob/jump up and down while scrolling. Swipe still animates
	   smoothly via the inline transition on the translateX. */
	height: 295px;
	align-items: center;
	margin-bottom: 16px;
}

.ai-mock-interview-card {
	display: flex;
	align-items: stretch;
	padding: 4px;
	width: 245px;
	height: 221.2px;
	min-width: 245px;
	background: #ffffff;
	border: 2.12696px solid #e9e9e9;
	box-shadow: 0px -4.25393px 10.6348px rgba(255, 255, 255, 0.9),
		0px 8.50785px 21.2696px rgba(0, 0, 0, 0.1);
	border-radius: 36px;
	transition: transform 0.3s ease, opacity 0.3s ease;
	/* opacity: 0.7; */
	flex-shrink: 0;
	overflow: hidden;
}

.ai-mock-interview-card-innercontainer.purple {
	background: linear-gradient(
		134.61deg,
		rgba(239, 234, 248, 0.56) 0.34%,
		rgba(242, 238, 251, 0.56) 99.66%
	);
	box-shadow: inset 0px 2.19876px 6.59628px rgba(0, 0, 0, 0.06);
}
.ai-mock-interview-card-innercontainer.blue {
	background: linear-gradient(
		134.61deg,
		rgba(237, 242, 252, 0.56) 0.34%,
		rgba(216, 227, 250, 0.56) 99.66%
	);
	box-shadow: inset 0px 2.53173px 7.59519px rgba(0, 0, 0, 0.06);
}
.ai-mock-interview-card-innercontainer.grey {
	background: linear-gradient(
		134.61deg,
		rgba(233, 241, 233, 0.56) 0.34%,
		rgba(239, 245, 240, 0.56) 99.66%
	);
	box-shadow: inset 0px 2.19876px 6.59628px rgba(0, 0, 0, 0.06);
}
.ai-mock-interview-card-innercontainer {
	width: 100%;
	padding: 15.6139px 14.6381px 15.6139px 15.6139px;
	border-radius: 30px;
}

.ai-mock-interview-card.active {
	transform: scale(1.2);
	opacity: 1;
	margin-left: 24px;
	margin-right: 24px;
}

.ai-mock-interview-card.no-card-transition {
	transition: none !important;
}

/* Profile match ring */
.ami-match-row {
	display: flex;
	align-items: center;
	gap: 8px;
}

.ami-ring-wrap {
	position: relative;
	width: 32px;
	min-width: 32px;
	height: 32px;
	flex-shrink: 0;
}

.ami-ring-wrap svg {
	width: 32px;
	height: 32px;
}

.ami-ring-label {
	position: absolute;
	top: 53%;
	left: 50%;
	transform: translate(-50%, -51%);
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: clamp(7px, 1.1vw, 8.47525px);
	line-height: 1;
	color: #000000;
	white-space: nowrap;
	max-width: 26px;
}

.ami-match-text {
	flex: 1 1 auto;
	min-width: 0;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 8.47525px;
	line-height: 1.4;
	letter-spacing: -0.03em;
	color: #596c98;
}
@media only screen and (max-width: 1028px) {
	.aicards-track {
		gap: 12px;
	}
	.ai-mock-interview-card {
		width: 215px;
		min-width: 215px;
		height: auto;
		min-height: 221.2px;
	}
	.ai-mock-interview-card.active {
		transform: scale(1.12);
		margin-left: 16px;
		margin-right: 16px;
	}
}
@media only screen and (min-width: 1029px) {
	.aicards-track {
		height: 280px;
		margin-bottom: 0;
	}
	.aicards-viewport {
		height: 295px;
	}
}
</style>
